import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, withLatestFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { Territory } from '../core/classes/territory';
import { Coverage } from '../shared/classes/coverage';
import { selectCounties } from '../state/location/location.reducer';

@Injectable({
  providedIn: 'root',
})
export class CoverageService {

  private readonly baseUrl = 'api/coverage/counties';
  private http = inject(HttpClient);
  private store = inject(Store);

  constructor() {
  }

  getCountyLayer(territories: Territory[]): Observable<{features: unknown[]}> {
    const url = `${this.baseUrl}`;
    let params = new HttpParams();

    params = params.set('states', territories.map(t => t.abbreviation).join());

    return this.http.get<Coverage[]>(url, { params }).pipe(
      map(data => data.map((metrics => new Coverage(metrics)))),
      withLatestFrom(this.store.select(selectCounties)),
      map(val => {
        const territoryIds = territories.map(t => t.id);
        const counties = val[1].filter(c => territoryIds.includes(c.stateId));

        const features = counties.map(county => {
          const coverage = val[0].find(c => county.geoid === c.fipsCode) || new Coverage();
          coverage.abbreviation = county.stateAbbreviation;
          coverage.fipsCode = county.geoid;
          coverage.county = county.name;

          return {
            type: 'Feature',
            geometry: JSON.parse(county.boundary),
            properties: coverage,
          };

        });

        return {
          features: features,
        };

      }),
    );
  }

}
